import React, { useState, useEffect } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Invalid verification link. No token found.");
      return;
    }

    const verify = async () => {
      try {
        const res = await fetch(`/api/auth/verify-email?token=${token}`);
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || data.message || "Verification failed");
        setStatus("success");
        setMessage("Your email has been verified successfully!");
        // Auto redirect to login after 3 seconds
        setTimeout(() => navigate("/login"), 3000);
      } catch (err) {
        setStatus("error");
        setMessage(err.message || "Verification failed. Link may have expired.");
      }
    };
    verify();
  }, []);

  return (
    <div className="auth-container">
      <div className="auth-card" style={{ textAlign: "center" }}>
        <h2>Email Verification</h2>

        {status === "verifying" && (
          <p className="muted">Verifying your email address...</p>
        )}

        {status === "success" && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}></div>
            <p style={{ color: "var(--success)", marginBottom: 8 }}>{message}</p>
            <p className="muted" style={{ marginBottom: 24 }}>
              Redirecting to sign in...
            </p>
            <Link to="/login" className="auth-button"
              style={{ display: "inline-block", textDecoration: "none", padding: "12px 32px" }}>
              Sign in now
            </Link>
          </>
        )}

        {status === "error" && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}></div>
            <p style={{ color: "var(--danger)", marginBottom: 16 }}>{message}</p>
            <Link to="/login" className="auth-button"
              style={{ display: "inline-block", textDecoration: "none", padding: "12px 32px" }}>
              Back to Sign in
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
